export default "__VITE_ASSET__CzHO6m03__"